/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_RetakeInputs */

const en_us2_body_assessment_retake = /** @type {(inputs: Body_Assessment_RetakeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Take it again`)
};

const pt_br2_body_assessment_retake = /** @type {(inputs: Body_Assessment_RetakeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tirar de novo`)
};

const es_419_body_assessment_retake = /** @type {(inputs: Body_Assessment_RetakeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tomarla de nuevo`)
};

const pt_pt2_body_assessment_retake = /** @type {(inputs: Body_Assessment_RetakeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tirar de novo`)
};

const fr_fr2_body_assessment_retake = /** @type {(inputs: Body_Assessment_RetakeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reprendre`)
};

const de_de2_body_assessment_retake = /** @type {(inputs: Body_Assessment_RetakeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noch mal`)
};

const it_it2_body_assessment_retake = /** @type {(inputs: Body_Assessment_RetakeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scatta di nuovo`)
};

/**
* | output |
* | --- |
* | "Take it again" |
*
* @param {Body_Assessment_RetakeInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_retake = /** @type {((inputs?: Body_Assessment_RetakeInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_RetakeInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_retake(inputs)
	if (locale === "es-419") return es_419_body_assessment_retake(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_retake(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_retake(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_retake(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_retake(inputs)
	return en_us2_body_assessment_retake(inputs)
});
export { body_assessment_retake as "body-assessment.retake" }